import { useFormik } from "formik";
import { getAluno } from "../../../api/aluno";
import { validateCupom, doPayment } from "../../../api/pagamento";
import { getPlano } from "../../../api/plano";
import { handleAddress } from "../../../api/cep";
import ErrorMsg, { ErrorApiMsg, SuccessApiMsg } from "./error-msg";
import {
  assineAgoraSchema,
  assineAgoraSemCadastroSchema,
} from "./validation-schema";
import { React, useEffect, useState, useCallback, useRef } from "react";
import { retrieveToken } from "./../../../hooks/use-token";
import { useNavigate } from "react-router-dom";
import pagarme from "pagarme/browser";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
import useCaptcha, { isCaptchaErrorMessage } from "../../../hooks/use-captcha";
import {
  classifyPaymentV5Response,
  getBoletoPdfUrl,
  getPixQrCodeUrl,
} from "../../../utils/payment-v5-response";
import CaptchaField from "./captcha-field";

const CheckoutForm = ({ cdPlano }) => {
  const [apiErrors, setApiErrors] = useState(null);
  const [apiSuccess, setApiSuccess] = useState(null);
  const [cupomErrors, setCupomErrors] = useState(null);
  const [cupomSuccess, setCupomSuccess] = useState(null);
  const [typeCupom, setTypeCupom] = useState(null);
  const [valueCupom, setValueCupom] = useState(null);
  const [isSubmting, setIsSubmiting] = useState(false);
  const [paymentBlockedDaily, setPaymentBlockedDaily] = useState(false);
  const [paymentMethod, setPaymentMethod] = useState("");
  const [dadosPlano, setDadosPlano] = useState(null);
  const [dadosAluno, setDadosAluno] = useState(null);
  const [dadosCep, setDadosCep] = useState(null);
  const [showCreditCard, setShowCreditCard] = useState(false);
  const [emailExists, setEmailExists] = useState(false);
  const tokenApi = retrieveToken();
  const navigate = useNavigate();
  const { executeRecaptcha } = useGoogleReCaptcha();
  const {
    captcha,
    captchaLoading,
    captchaLoadError,
    loadCaptcha,
    hasValidCaptcha,
    secondsLeft,
  } = useCaptcha({ autoLoad: true, autoReloadOnExpire: true });
  const formikHelpersRef = useRef({});
  const initialValuesFormAssinar = {
    name: "",
    email: "",
    cpf: "",
    telefone: "",
    bairro: "",
    numero: "",
    cidade: "",
    cep: "",
    endereco: "",
    complemento: "",
    estado: "",
    formaPagamento: "",
    nome_dono_cartao: "",
    numero_cartao: "",
    mes: "",
    ano: "",
    cvv: "",
    parcelas: "",
    captcha: "",
  };
  const initialValuesFormAssinarSemCadastro = {
    name: "",
    email: "",
    email_confirme: "",
    password: "",
    passwordConfirmation: "",
    cpf: "",
    telefone: "",
    bairro: "",
    numero: "",
    cidade: "",
    cep: "",
    endereco: "",
    complemento: "",
    estado: "",
    formaPagamento: "",
    nome_dono_cartao: "",
    numero_cartao: "",
    mes: "",
    ano: "",
    cvv: "",
    parcelas: "",
    captcha: "",
  };
  const handleReCaptchaVerify = useCallback(async () => {
    if (!executeRecaptcha) {
      console.log("executeRecaptcha not yet available");
      return;
    }

    const token = await executeRecaptcha("signup");

    return token;
  }, [executeRecaptcha]);

  useEffect(() => {
    console.log("typeCupom", typeCupom);
  }, [typeCupom]);

  useEffect(() => {
    if (dadosPlano == null) {
      getPlano(tokenApi, cdPlano).then(function (result) {
        setDadosPlano(result);
      });
    }

    if (dadosAluno == null && tokenApi) {
      getAluno(tokenApi).then(function (result) {
        setDadosAluno(result);
        setFieldValue("name", result.nome);
        setFieldValue("email", result.email);
        if (result.email != "") {
          setEmailExists(true);
        }
        setFieldValue("cpf", result.cpf != null ? result.cpf : "");
        setFieldValue(
          "telefone",
          result.telefone != null ? result.telefone.replace(/\D/g, "") : ""
        );
        setFieldValue(
          "instagram",
          result.instagram != null ? result.instagram : ""
        );
      });
    }
  }, []);

  const handleCardHash = async (
    cardNumber,
    cardHolderName,
    cardExpirationDate,
    Cvv
  ) => {
    const card = {
      card_number: cardNumber,
      card_holder_name: cardHolderName,
      card_expiration_date: cardExpirationDate,
      card_cvv: Cvv,
    };

    let cardValidations = pagarme.validate({ card: card });

    if (cardValidations.card.card_cvv == false) {
      setApiErrors("Erro! Verifique o código de segurança");
      return false;
    } else if (cardValidations.card.card_expiration_date == false) {
      setApiErrors(
        "Erro! Verifique a data de validade do seu cartão, informe mês e o ano no outro campo"
      );
      return false;
    } else if (cardValidations.card.card_holder_name == false) {
      setApiErrors(
        "Erro! Digite o nome completo do dono do cartão, sem acentos."
      );
      return false;
    } else if (cardValidations.card.card_number == false) {
      setApiErrors(
        "Erro! Verifique o número do cartão digitado, informe somente números, sem espaços ou hífen."
      );
      return false;
    } else {
      const options = {
        method: "POST",
        headers: {
          accept: "application/json",
          "content-type": "application/json",
        },
        body: JSON.stringify({
          card: {
            number: card.card_number.replace(/\D/g, ""),
            holder_name: card.card_holder_name,
            exp_month: parseInt(card.card_expiration_date.slice(0, 2)),
            exp_year: parseInt(card.card_expiration_date.slice(2)),
            cvv: card.card_cvv,
          },
          type: "card",
        }),
      };

      return await fetch(
        "https://api.pagar.me/core/v5/tokens?appId=pk_n1Ag8rtEOHPZprk3",
        options
      )
        .then((response) => response.json())
        .then((response) => {
          console.log(response);
          return response;
        })
        .catch((err) => {
          console.error(err);
          return "Erro! Requisição é inválida, verifique todos os dados do cartão e o CPF digitado.";
        });
    }
  };

  const removeAcentosECaracteresEspeciais = (str) => {
    return str
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/[^\w\s]/gi, "");
  };

  const refreshCaptcha = useCallback(async () => {
    const { setFieldValue, setFieldError } = formikHelpersRef.current;
    if (setFieldValue) setFieldValue("captcha", "");
    if (setFieldError) setFieldError("captcha", undefined);
    await loadCaptcha();
  }, [loadCaptcha]);

  /**
   * Trata a resposta de POST /api/pagamento/v5 conforme a matriz de status/body.
   * Retorna true se houve redirecionamento de sucesso (order Pagar.me).
   */
  const handlePaymentV5Response = useCallback(
    async (paymentResult, { resetForm, formaPagamento }) => {
      const { setFieldError, setFieldTouched, setFieldValue } =
        formikHelpersRef.current;

      const classified = classifyPaymentV5Response(paymentResult);

      if (classified.kind !== "pagarme_order") {
        console.warn("[pagamento/v5]", {
          kind: classified.kind,
          httpStatus: paymentResult.httpStatus,
          body: paymentResult.data,
          rawText: paymentResult.isJson ? undefined : paymentResult.rawText,
        });
      }

      // Aplicar erros de campo (422)
      if (classified.fieldErrors) {
        Object.entries(classified.fieldErrors).forEach(([field, message]) => {
          const formField =
            field === "captcha_id" || field === "captcha" ? "captcha" : field;

          if (setFieldTouched) setFieldTouched(formField, true, false);
          if (setFieldError) setFieldError(formField, message);
        });
      }

      if (classified.captchaMessage) {
        if (setFieldTouched) setFieldTouched("captcha", true, false);
        if (setFieldError) setFieldError("captcha", classified.captchaMessage);
      }

      if (classified.blockDaily) {
        setPaymentBlockedDaily(true);
      }

      // CAPTCHA: regenerar quando o desafio foi invalidado/consumido
      if (classified.reloadCaptcha) {
        if (setFieldValue) setFieldValue("captcha", "");
        await loadCaptcha();
      }

      // Sucesso = order Pagar.me bruta (sem { status: true })
      if (classified.kind === "pagarme_order" && classified.order) {
        const order = classified.order;

        setApiSuccess(
          "Seu pedido foi processado! Aguarde que você será redirecionado.."
        );
        resetForm();

        const params = new URLSearchParams({
          transaction: String(order.id),
          transactionStatus: String(order.status),
        });

        if (formaPagamento === "boleto") {
          const linkBoleto = getBoletoPdfUrl(order);
          if (linkBoleto) params.set("linkBoleto", linkBoleto);
        }

        if (formaPagamento === "pix") {
          const pixQrCode = getPixQrCodeUrl(order);
          if (pixQrCode) params.set("pixQrCode", pixQrCode);
        }

        navigate(`/pagamento-finalizado?${params.toString()}`);
        return true;
      }

      setApiErrors(classified.userMessage);
      return false;
    },
    [loadCaptcha, navigate]
  );

  const buildCheckoutPayload = (values, captchaPayload) => ({
    name: values.name,
    email: values.email,
    cpf: values.cpf,
    telefone: values.telefone,
    bairro: values.bairro,
    numero: values.numero,
    cidade: values.cidade,
    endereco: values.endereco,
    cep: dadosCep,
    complemento: values.complemento,
    estado: values.estado,
    formaPagamento: values.formaPagamento,
    plano: dadosPlano.cd_plano,
    cupom: values.cupom,
    recaptchaToken: values.recaptchaToken,
    ...captchaPayload,
    password: dadosAluno == null ? values.password : false,
    createAluno: dadosAluno == null ? true : false,
  });

  // form — Google reCAPTCHA + CAPTCHA Laravel (ambos no payload)
  const handleOnSubmit = async (values, { resetForm }) => {
    if (isSubmting) return;

    if (paymentBlockedDaily) {
      setApiErrors(
        "Limite diário de pagamentos atingido. Tente novamente amanhã."
      );
      return;
    }

    if (!hasValidCaptcha || !captcha?.captcha_id) {
      setApiErrors("Aguarde o carregamento do código de verificação.");
      return;
    }

    if (secondsLeft !== null && secondsLeft <= 0) {
      setApiErrors("Código de verificação expirado. Gerando um novo...");
      await refreshCaptcha();
      return;
    }

    setIsSubmiting(true);
    setApiErrors(null);
    setApiSuccess(null);

    const token = await handleReCaptchaVerify();

    if (!token) {
      setApiErrors(
        "Validação de segurança não autorizada. Atualize a página e tente novamente."
      );
      await refreshCaptcha();
      setIsSubmiting(false);
      return;
    }

    values.recaptchaToken = token;

    // Snapshot do desafio atual — após sucesso da validação no backend o id é invalidado
    const captchaPayload = {
      captcha_id: captcha.captcha_id,
      captcha: values.captcha,
    };

    const formaPagamento = values.formaPagamento || paymentMethod;

    try {
      if (formaPagamento === "credit_card") {
        const cardHash = await handleCardHash(
          values.numero_cartao,
          removeAcentosECaracteresEspeciais(values.nome_dono_cartao),
          values.mes + values.ano,
          values.cvv
        );

        if (!cardHash || !cardHash.id) {
          if (typeof cardHash === "string") {
            setApiErrors(cardHash);
          } else {
            setApiErrors(
              "Não foi possível validar os dados do cartão. Verifique e tente novamente."
            );
          }
          setIsSubmiting(false);
          return;
        }

        const paymentResult = await doPayment(retrieveToken(), {
          ...buildCheckoutPayload(values, captchaPayload),
          nome_dono_cartao: values.nome_dono_cartao,
          card_hash: cardHash.id,
          parcelas: values.parcelas,
        });

        await handlePaymentV5Response(paymentResult, {
          resetForm,
          formaPagamento: "credit_card",
        });
      } else if (formaPagamento === "boleto") {
        const paymentResult = await doPayment(
          retrieveToken(),
          buildCheckoutPayload(values, captchaPayload)
        );

        await handlePaymentV5Response(paymentResult, {
          resetForm,
          formaPagamento: "boleto",
        });
      } else if (formaPagamento === "pix") {
        const paymentResult = await doPayment(
          retrieveToken(),
          buildCheckoutPayload(values, captchaPayload)
        );

        await handlePaymentV5Response(paymentResult, {
          resetForm,
          formaPagamento: "pix",
        });
      } else {
        setApiErrors("Selecione uma forma de pagamento.");
      }
    } catch (error) {
      console.error("[pagamento/v5] Error:", error);
      setApiErrors(
        "Não foi possível concluir o pagamento. Tente novamente em instantes."
      );
      await refreshCaptcha();
    } finally {
      setIsSubmiting(false);
    }
  };

  const handleValidateCupom = () => {
    setCupomErrors(null);
    setCupomSuccess(null);

    validateCupom(tokenApi, {
      cd_plano: cdPlano,
      cupom: values.cupom,
    }).then(function (result) {
      if (result.error) {
        setCupomErrors(result.error);
      } else {
        if (result.porcentagem > 0) {
          setTypeCupom("Porcentagem");
          setValueCupom(result.porcentagem);
        } else if (result.valor > 0) {
          setTypeCupom("Valor");
          setValueCupom(result.valor);
        }

        setCupomSuccess("Seu cupom foi aplicado com sucesso!");
      }
    });
  };

  // use formik
  const {
    handleChange,
    handleSubmit,
    handleBlur,
    errors,
    values,
    touched,
    setFieldValue,
    setFieldError,
    setFieldTouched,
  } = useFormik({
    validateOnChange: false,
    validateOnBlur: false,
    initialValues:
      dadosAluno == null
        ? initialValuesFormAssinarSemCadastro
        : initialValuesFormAssinar,
    validationSchema:
      dadosAluno == null ? assineAgoraSemCadastroSchema : assineAgoraSchema,
    onSubmit: handleOnSubmit,
  });

  formikHelpersRef.current = {
    setFieldValue,
    setFieldError,
    setFieldTouched,
  };

  // Limpa o input quando um novo desafio é gerado (ex.: auto-expiração)
  const lastCaptchaIdRef = useRef(null);
  useEffect(() => {
    const id = captcha?.captcha_id || null;
    if (id && lastCaptchaIdRef.current && id !== lastCaptchaIdRef.current) {
      setFieldValue("captcha", "");
      setFieldError("captcha", undefined);
    }
    lastCaptchaIdRef.current = id;
  }, [captcha?.captcha_id, setFieldValue, setFieldError]);

  useEffect(() => {
    const errorEntries = Object.entries(errors).filter(([, error]) => error);
    if (errorEntries.length > 0) {
      const captchaOnlyError =
        errorEntries.length === 1 &&
        errorEntries[0][0] === "captcha" &&
        isCaptchaErrorMessage(errorEntries[0][1]);

      if (captchaOnlyError) {
        setApiErrors(errorEntries[0][1]);
      } else {
        const campos = errorEntries.map(([key]) => key);
        setApiErrors(
          `Existem campos obrigatórios não preenchidos: ${campos.join(", ")}.`
        );
      }
    } else {
      setApiErrors(null);
    }
  }, [errors]);

  function buildParcelamento(numeroParcelas) {
    const parcelas = [];

    for (let i = 1; i <= numeroParcelas; i++) {
      parcelas.push(<option value={i}>{i}x</option>);
    }

    return parcelas;
  }

  function handleChangeCep(value) {
    if (value.length >= 8) {
      let cep = value.replace(/\D/g, "");

      setDadosCep(cep);

      handleAddress(cep).then(function (result) {
        if (!result.erro) {
          setFieldValue("bairro", result.bairro);
          setFieldValue("cidade", result.localidade);
          setFieldValue("endereco", result.logradouro);
          setFieldValue("estado", result.uf);
        } else {
          setApiErrors("CEP não encontrado");
        }
      });
    }
  }

  if (dadosPlano != null) {
    return (
      <section className="checkout-area pb-70">
        <div className="container">
          <form onSubmit={handleSubmit} autoComplete="new-payment">
            <div className="row">
              <div className="col-lg-6">
                <div className="checkbox-form">
                  <h3>Seus dados</h3>
                  <div className="row">
                    <div className="col-md-12">
                      <div className="checkout-form-list">
                        <label>
                          Nome completo <span className="required">*</span>
                        </label>
                        <input
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.name}
                          name="name"
                          type="text"
                          placeholder="Nome completo"
                          autoComplete="off"
                        />
                        {touched.name && <ErrorMsg error={errors.name} />}
                      </div>
                    </div>

                    {dadosAluno == null && (
                      <div className="col-md-6 col-xs-12">
                        <div className="checkout-form-list">
                          <label>
                            Informe seu e-mail{" "}
                            <span className="required">*</span>
                          </label>
                          <input
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.email}
                            name="email"
                            type="text"
                            placeholder="E-mail"
                            autoComplete="off"
                          />
                          {touched.email && <ErrorMsg error={errors.email} />}
                        </div>
                      </div>
                    )}
                    {dadosAluno == null && (
                      <div className="col-md-6 col-xs-12">
                        <div className="checkout-form-list">
                          <label>
                            Confirme seu e-mail{" "}
                            <span className="required">*</span>
                          </label>
                          <input
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.email_confirme}
                            name="email_confirme"
                            type="text"
                            placeholder="Confirme seu e-mail"
                            autoComplete="off"
                          />
                          {touched.email && <ErrorMsg error={errors.email} />}
                        </div>
                      </div>
                    )}
                    {dadosAluno == null && (
                      <div className="col-md-6 col-xs-12">
                        <h5>Senha</h5>
                        <div className="checkout-form-list">
                          <input
                            value={values.password}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            type="password"
                            placeholder="Sua senha"
                            name="password"
                          />
                          {touched.password && (
                            <ErrorMsg error={errors.password} />
                          )}
                        </div>
                      </div>
                    )}
                    {dadosAluno == null && (
                      <div className="col-md-6 col-xs-12">
                        <h5>Confirme a sua senha</h5>
                        <div className="checkout-form-list">
                          <input
                            value={values.passwordConfirmation}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            type="password"
                            placeholder="Confirme a senha"
                            name="passwordConfirmation"
                          />
                          {touched.passwordConfirmation && (
                            <ErrorMsg error={errors.passwordConfirmation} />
                          )}
                        </div>
                      </div>
                    )}

                    {dadosAluno != null && (
                      <div className="col-md-12">
                        <div className="checkout-form-list">
                          <label>
                            E-mail da sua conta{" "}
                            {emailExists ? "(somente leitura)" : ""}
                            <span className="required">
                              {emailExists ? "" : "*"}
                            </span>
                          </label>
                          <input
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.email}
                            name="email"
                            type="text"
                            placeholder="E-mail"
                            disabled={emailExists}
                            autoComplete="off"
                          />
                          {touched.email && <ErrorMsg error={errors.email} />}
                        </div>
                      </div>
                    )}

                    <div className="col-md-6">
                      <div className="checkout-form-list">
                        <label>
                          CPF <span className="required">*</span>
                        </label>
                        <input
                          onChange={(e) => {
                            if (/^\d*$/.test(e.target.value)) handleChange(e);
                          }}
                          onBlur={handleBlur}
                          value={values.cpf}
                          name="cpf"
                          type="text"
                          placeholder="Somente números"
                          maxLength="11"
                          autoComplete="off"
                        />
                        {touched.cpf && <ErrorMsg error={errors.cpf} />}
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="checkout-form-list">
                        <label>
                          Celular c/ DDD <span className="required">*</span>
                        </label>
                        <input
                          onChange={(e) => {
                            if (/^\d*$/.test(e.target.value)) handleChange(e);
                          }}
                          onBlur={handleBlur}
                          value={values.telefone}
                          name="telefone"
                          type="text"
                          placeholder="Somente números"
                          maxLength="11"
                          autoComplete="off"
                        />
                        {touched.telefone && (
                          <ErrorMsg error={errors.telefone} />
                        )}
                      </div>
                    </div>
                  </div>
                  <h3>Endereço</h3>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="checkout-form-list">
                        <label>
                          CEP <span className="required">*</span>
                        </label>
                        <input
                          name="cep"
                          type="text"
                          placeholder="Digite o Cep (somente números)"
                          value={values.cep}
                          onChange={(e) => {
                            handleChangeCep(e.target.value);
                            handleChange(e);
                          }}
                          maxLength="8"
                          onBlur={handleBlur}
                          autoComplete="off"
                        />
                        {touched.cep && <ErrorMsg error={errors.cep} />}
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="checkout-form-list">
                        <label>
                          Endereço (Av., Rua){" "}
                          <span className="required">*</span>
                        </label>
                        <input
                          value={values.endereco}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          name="endereco"
                          type="text"
                          placeholder="Endereço"
                          autoComplete="off"
                        />
                        {touched.endereco && (
                          <ErrorMsg error={errors.endereco} />
                        )}
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="checkout-form-list">
                        <label>
                          Número <span className="required">*</span>
                        </label>
                        <input
                          value={values.numero}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          name="numero"
                          type="text"
                          placeholder="Número"
                          autoComplete="off"
                        />
                        {touched.numero && <ErrorMsg error={errors.numero} />}
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="checkout-form-list">
                        <label>Complemento </label>
                        <input
                          value={values.complemento}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          name="complemento"
                          type="text"
                          placeholder="Complemento"
                          autoComplete="off"
                        />
                        {touched.complemento && (
                          <ErrorMsg error={errors.complemento} />
                        )}
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="checkout-form-list">
                        <label>
                          Bairro <span className="required">*</span>
                        </label>
                        <input
                          value={values.bairro}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          name="bairro"
                          type="text"
                          placeholder="Bairro"
                          autoComplete="off"
                        />
                        {touched.bairro && <ErrorMsg error={errors.bairro} />}
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="checkout-form-list">
                        <label>
                          Cidade <span className="required">*</span>
                        </label>
                        <input
                          value={values.cidade}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          name="cidade"
                          type="text"
                          placeholder="Cidade"
                          autoComplete="off"
                        />
                        {touched.cidade && <ErrorMsg error={errors.cidade} />}
                      </div>
                    </div>

                    <div className="col-md-12">
                      <div className="country-select">
                        <label>
                          Estado <span className="required">*</span>
                        </label>
                        <select
                          name="estado"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.estado}
                          autoComplete="off"
                        >
                          <option value="">Selecione</option>
                          <option value="AC">Acre</option>
                          <option value="AL">Alagoas</option>
                          <option value="AP">Amapá</option>
                          <option value="AM">Amazonas</option>
                          <option value="BA">Bahia</option>
                          <option value="CE">Ceará</option>
                          <option value="DF">Distrito Federal</option>
                          <option value="ES">Espirito Santo</option>
                          <option value="GO">Goiás</option>
                          <option value="MA">Maranhão</option>
                          <option value="MS">Mato Grosso do Sul</option>
                          <option value="MT">Mato Grosso</option>
                          <option value="MG">Minas Gerais</option>
                          <option value="PA">Pará</option>
                          <option value="PB">Paraíba</option>
                          <option value="PR">Paraná</option>
                          <option value="PE">Pernambuco</option>
                          <option value="PI">Piauí</option>
                          <option value="RJ">Rio de Janeiro</option>
                          <option value="RN">Rio Grande do Norte</option>
                          <option value="RS">Rio Grande do Sul</option>
                          <option value="RO">Rondônia</option>
                          <option value="RR">Roraima</option>
                          <option value="SC">Santa Catarina</option>
                          <option value="SP">São Paulo</option>
                          <option value="SE">Sergipe</option>
                          <option value="TO">Tocantins</option>
                        </select>
                        {touched.estado && <ErrorMsg error={errors.estado} />}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="your-order mb-30 ">
                  <h3>Seu pedido</h3>
                  <div className="your-order-table table-responsive">
                    <table>
                      <thead>
                        <tr>
                          <th className="product-name">Plano</th>
                          <th className="product-total text-end">Total</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr key="0" className="cart_item">
                          <td className="product-name">
                            <strong className="product-quantity"> × 1</strong>{" "}
                            {dadosPlano.titulo}
                          </td>
                          <td className="product-total text-end">
                            <span className="amount">
                              R${" "}
                              {dadosPlano.valor_promocao // casas decimais
                                .replace(".", ",")
                                .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.")}
                            </span>
                          </td>
                        </tr>

                        {cupomSuccess !== null && (
                          <>
                            <tr key="0" className="cart_item">
                              <td className="product-name">
                                <strong className="product-quantity">
                                  Cupom
                                </strong>{" "}
                                {typeCupom == "Porcentagem"
                                  ? valueCupom + "%"
                                  : "R$" +
                                    valueCupom // casas decimais
                                      .replace(".", ",")
                                      .replace(
                                        /(\d)(?=(\d{3})+(?!\d))/g,
                                        "$1."
                                      )}
                              </td>
                              <td className="product-total text-end">
                                <span className="amount">
                                  - R${" "}
                                  {typeCupom == "Porcentagem"
                                    ? (
                                        (dadosPlano.valor_promocao *
                                          valueCupom) /
                                        100
                                      )
                                        .toString() // casas decimais
                                        .replace(".", ",")
                                        .replace(
                                          /(\d)(?=(\d{3})+(?!\d))/g,
                                          "$1."
                                        )
                                    : valueCupom // casas decimais
                                        .replace(".", ",")
                                        .replace(
                                          /(\d)(?=(\d{3})+(?!\d))/g,
                                          "$1."
                                        )}
                                </span>
                              </td>
                            </tr>
                          </>
                        )}
                      </tbody>
                    </table>
                  </div>

                  <div className="payment-method">
                    <div className="accordion" id="accordionExample">
                      <h4>Cupom</h4>
                      <div className="your-order-table table-responsive">
                        <p>Digite o seu cupom de desconto:</p>
                        <div className="col-md-12">
                          <div className="checkout-form-list">
                            <input
                              style={{ width: "50%" }}
                              value={values.cupom}
                              name="cupom"
                              type="text"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              placeholder="Cupom"
                            />{" "}
                            <button
                              onClick={handleValidateCupom}
                              type="button"
                              className="btn btn-outline-secondary"
                              autoComplete="off"
                            >
                              {" "}
                              {isSubmting ? (
                                <span>
                                  <i className="fal fa-spinner"></i>
                                </span>
                              ) : (
                                "Aplicar"
                              )}
                            </button>
                            {touched.cupom && <ErrorMsg error={errors.cupom} />}
                            {cupomErrors && <ErrorApiMsg error={cupomErrors} />}
                            {cupomSuccess && (
                              <SuccessApiMsg msg={cupomSuccess} />
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <h3 style={{ marginTop: "20px" }}>Forma de pagamento</h3>

                  <div className="payment-method">
                    <div className="accordion" id="accordionExample">
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="radio"
                          value="credito"
                          name="formaPagamento"
                          id="formaPagamento1"
                          onChange={(e) => {
                            setShowCreditCard(true);
                            setPaymentMethod("credit_card");
                            setFieldValue("formaPagamento", "credit_card");
                          }}
                        />
                        <label
                          className="form-check-label"
                          htmlFor="formaPagamento1"
                        >
                          Cartão de Crédito
                        </label>
                      </div>

                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="radio"
                          value-="boleto"
                          name="formaPagamento"
                          id="formaPagamento2"
                          onChange={(e) => {
                            setShowCreditCard(false);
                            setPaymentMethod("boleto");
                            setFieldValue("formaPagamento", "boleto");
                          }}
                        />
                        <label
                          className="form-check-label"
                          htmlFor="formaPagamento2"
                        >
                          Boleto Bancário
                        </label>
                      </div>

                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="radio"
                          value-="pix"
                          name="formaPagamento"
                          id="formaPagamento3"
                          onChange={(e) => {
                            setShowCreditCard(false);
                            setPaymentMethod("pix");
                            setFieldValue("formaPagamento", "pix");
                          }}
                        />
                        <label
                          className="form-check-label"
                          htmlFor="formaPagamento2"
                        >
                          PIX
                        </label>
                      </div>

                      {touched.formaPagamento && (
                        <ErrorMsg error={errors.formaPagamento} />
                      )}

                      {showCreditCard && (
                        <div className="row" style={{ marginTop: "20px" }}>
                          <div className="col-md-12">
                            <div className="checkout-form-list">
                              <label>
                                Nome completo dono do cartão{" "}
                                <span className="required">*</span>
                              </label>
                              <input
                                value={values.nome_dono_cartao}
                                name="nome_dono_cartao"
                                type="text"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                placeholder="Digite o nome dono do cartão"
                              />
                              {touched.nome_dono_cartao && (
                                <ErrorMsg error={errors.nome_dono_cartao} />
                              )}
                            </div>
                          </div>

                          <div className="col-md-12">
                            <div className="checkout-form-list">
                              <label>
                                Número do cartão{" "}
                                <span className="required">*</span>
                              </label>
                              <input
                                value={values.numero_cartao}
                                maxLength={16}
                                name="numero_cartao"
                                type="text"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                placeholder="Digite o número do cartão"
                              />
                              {touched.numero_cartao && (
                                <ErrorMsg error={errors.numero_cartao} />
                              )}
                            </div>
                          </div>

                          <div className="col-md-4">
                            <div className="country-select">
                              <label>
                                Mês <span className="required">*</span>
                              </label>
                              <select
                                value={values.mes}
                                name="mes"
                                onChange={handleChange}
                                onBlur={handleBlur}
                              >
                                <option value="">MM</option>
                                <option value="01">01</option>
                                <option value="02">02</option>
                                <option value="03">03</option>
                                <option value="04">04</option>
                                <option value="05">05</option>
                                <option value="06">06</option>
                                <option value="07">07</option>
                                <option value="08">08</option>
                                <option value="09">09</option>
                                <option value="10">10</option>
                                <option value="11">11</option>
                                <option value="12">12</option>
                              </select>
                              {touched.mes && <ErrorMsg error={errors.mes} />}
                            </div>
                          </div>

                          <div className="col-md-4">
                            <div className="country-select">
                              <label>
                                Ano <span className="required">*</span>
                              </label>
                              <select
                                value={values.ano}
                                name="ano"
                                onChange={handleChange}
                                onBlur={handleBlur}
                              >
                                <option value="">AA</option>
                                {Array.from(
                                  { length: 10 },
                                  (v, k) => k + new Date().getFullYear()
                                ).map((ano) => (
                                  <option
                                    value={ano.toString().slice(-2)}
                                    key={ano}
                                  >
                                    {ano}
                                  </option>
                                ))}
                              </select>
                              {touched.ano && <ErrorMsg error={errors.ano} />}
                            </div>
                          </div>

                          <div className="col-md-4">
                            <div className="checkout-form-list">
                              <label>
                                Código (CVV) <span className="required">*</span>
                              </label>
                              <input
                                value={values.cvv}
                                maxLength="4"
                                name="cvv"
                                type="text"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                placeholder="CVV"
                              />
                              {touched.cvv && <ErrorMsg error={errors.cvv} />}
                            </div>
                          </div>

                          <div className="col-md-12">
                            <div className="country-select">
                              <label>
                                Selecione o número de parcelas{" "}
                                <span className="required">*</span>
                              </label>
                              <select
                                name="parcelas"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.parcelas}
                              >
                                {dadosPlano.map}
                                <option value="">Selecione</option>
                                {buildParcelamento(dadosPlano.parcelas)}
                              </select>
                              {touched.parcelas && (
                                <ErrorMsg error={errors.parcelas} />
                              )}
                            </div>
                          </div>
                        </div>
                      )}
                    </div>

                    <CaptchaField
                      captcha={captcha}
                      captchaLoading={captchaLoading}
                      captchaLoadError={captchaLoadError}
                      onRefresh={refreshCaptcha}
                      value={values.captcha}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={errors.captcha}
                      touched={touched.captcha}
                      secondsLeft={secondsLeft}
                    />

                    <div className="order-button-payment mt-20">
                      <button
                        type="submit"
                        disabled={
                          isSubmting ||
                          captchaLoading ||
                          !hasValidCaptcha ||
                          paymentBlockedDaily ||
                          (secondsLeft !== null && secondsLeft <= 0)
                        }
                        className="e-btn e-btn-7 w-100"
                      >
                        {isSubmting ? (
                          <span>
                            <i className="fal fa-spinner"></i>
                          </span>
                        ) : paymentBlockedDaily ? (
                          "Limite diário atingido"
                        ) : (
                          "Realizar Pagamento"
                        )}
                      </button>
                    </div>
                    <div style={{ marginTop: "20px" }}>
                      {apiErrors && <ErrorApiMsg error={apiErrors} />}
                      {apiSuccess && <SuccessApiMsg msg={apiSuccess} />}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </section>
    );
  }
};

export default CheckoutForm;
